<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">
                {{ 'Confirm changes'|translate }}
            </span>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 pb-0 m-0" fusePerfectScrollbar *ngIf="!confirmingUser">
        {{'Someone else has to confirm provided changes by scanning the card.'|translate}}
        <div *ngIf="differentUserRequired" style="font-weight: bold; color: red;">
            <br/>{{'Acceptance has to be done by different user!'|translate}}
        </div>
    </div>
    <div mat-dialog-content class="p-24 pb-0 m-0" fusePerfectScrollbar *ngIf="confirmingUser">
        <b>{{confirmingUser.firstName}} {{confirmingUser.lastName}}</b> - {{'Do you really want to confirm changes?'|translate}}
    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="end center">
        <button
                [disabled]="scanningInProgress"
                mat-button
                class="mr-8"
                (click)="closeConfirmation($event)"
                aria-label="Cancel">
            {{'Cancel'|translate}}
        </button>
        <button
                *ngIf="allowConfirm"
                mat-button
                class="mr-8"
                (click)="matDialogRef.close(confirmingUser.id)"
                aria-label="Confirm">
            {{'Confirm'|translate}}
        </button>

    </div>
</div>
